import React from 'react';

// 1. Automation SVG with animation
export const AutomationSVG = ({ className }) => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 240 240"
            className={className}
        >
            {/* Background circles */}
            <circle cx="120" cy="120" r="100" fill="none" stroke="#6B21A8" strokeWidth="1" strokeOpacity="0.1" />
            <circle cx="120" cy="120" r="80" fill="none" stroke="#7E22CE" strokeWidth="1" strokeOpacity="0.2" />
            <circle cx="120" cy="120" r="60" fill="none" stroke="#9333EA" strokeWidth="1" strokeOpacity="0.3" />

            {/* Gear animations */}
            <g className="animate-spin-slow" style={{ transformOrigin: "120px 120px", animationDuration: "20s" }}>
                <circle cx="120" cy="50" r="12" fill="#9333EA" fillOpacity="0.7" />
                <path d="M120 38 L120 26" stroke="#9333EA" strokeWidth="4" strokeLinecap="round" />
                <path d="M120 62 L120 74" stroke="#9333EA" strokeWidth="4" strokeLinecap="round" />
                <path d="M108 50 L96 50" stroke="#9333EA" strokeWidth="4" strokeLinecap="round" />
                <path d="M132 50 L144 50" stroke="#9333EA" strokeWidth="4" strokeLinecap="round" />
            </g>

            <g className="animate-spin-slow" style={{ transformOrigin: "120px 120px", animationDuration: "15s", animationDirection: "reverse" }}>
                <circle cx="50" cy="120" r="14" fill="#A855F7" fillOpacity="0.7" />
                <path d="M50 106 L50 94" stroke="#A855F7" strokeWidth="4" strokeLinecap="round" />
                <path d="M50 134 L50 146" stroke="#A855F7" strokeWidth="4" strokeLinecap="round" />
                <path d="M36 120 L24 120" stroke="#A855F7" strokeWidth="4" strokeLinecap="round" />
                <path d="M64 120 L76 120" stroke="#A855F7" strokeWidth="4" strokeLinecap="round" />
            </g>

            <g className="animate-spin-slow" style={{ transformOrigin: "120px 120px", animationDuration: "12s" }}>
                <circle cx="190" cy="120" r="10" fill="#C084FC" fillOpacity="0.7" />
                <path d="M190 110 L190 98" stroke="#C084FC" strokeWidth="4" strokeLinecap="round" />
                <path d="M190 130 L190 142" stroke="#C084FC" strokeWidth="4" strokeLinecap="round" />
                <path d="M180 120 L168 120" stroke="#C084FC" strokeWidth="4" strokeLinecap="round" />
                <path d="M200 120 L212 120" stroke="#C084FC" strokeWidth="4" strokeLinecap="round" />
            </g>

            {/* Process flow lines */}
            <path
                d="M50 120 Q 85 80 120 50"
                fill="none"
                stroke="#A855F7"
                strokeWidth="2"
                strokeDasharray="4 4"
                className="animate-dash"
            />
            <path
                d="M120 50 Q 155 80 190 120"
                fill="none"
                stroke="#A855F7"
                strokeWidth="2"
                strokeDasharray="4 4"
                className="animate-dash-reverse"
            />
            <path
                d="M190 120 Q 155 160 120 190"
                fill="none"
                stroke="#A855F7"
                strokeWidth="2"
                strokeDasharray="4 4"
                className="animate-dash"
            />
            <path
                d="M120 190 Q 85 160 50 120"
                fill="none"
                stroke="#A855F7"
                strokeWidth="2"
                strokeDasharray="4 4"
                className="animate-dash-reverse"
            />

            {/* Central node with pulse animation */}
            <circle cx="120" cy="120" r="20" fill="#A855F7" className="animate-pulse" style={{ animationDuration: "3s" }} />
            <circle cx="120" cy="120" r="12" fill="#2D3748" />
            <circle cx="120" cy="120" r="6" fill="#C084FC" />

            {/* Small data nodes on the paths with pulse */}
            <circle cx="120" cy="190" r="8" fill="#A855F7" fillOpacity="0.8" className="animate-pulse" style={{ animationDuration: "2s" }} />
            <circle cx="120" cy="190" r="4" fill="#2D3748" />
        </svg>
    );
};

// 2. Analysis SVG with animation
export const AnalysisSVG = ({ className }) => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 240 240"
            className={className}
        >
            {/* Background grid */}
            <defs>
                <pattern id="grid" width="20" height="20" patternUnits="userSpaceOnUse">
                    <path d="M 20 0 L 0 0 0 20" fill="none" stroke="#0D9488" strokeWidth="0.5" strokeOpacity="0.2" />
                </pattern>
            </defs>
            <rect width="240" height="240" fill="url(#grid)" />

            {/* Axis lines */}
            <line x1="40" y1="200" x2="200" y2="200" stroke="#0D9488" strokeWidth="2" />
            <line x1="40" y1="40" x2="40" y2="200" stroke="#0D9488" strokeWidth="2" />

            {/* Chart elements */}
            <path
                d="M40 180 L70 150 L100 160 L130 120 L160 90 L190 60"
                fill="none"
                stroke="#2DD4BF"
                strokeWidth="3"
                strokeDasharray="240"
                strokeDashoffset="240"
                className="animate-draw-line"
            />

            {/* Data points with pulse animation */}
            <circle cx="40" cy="180" r="6" fill="#14B8A6" className="animate-pulse" style={{ animationDuration: "2s", animationDelay: "0.5s" }} />
            <circle cx="70" cy="150" r="6" fill="#14B8A6" className="animate-pulse" style={{ animationDuration: "2s", animationDelay: "1s" }} />
            <circle cx="100" cy="160" r="6" fill="#14B8A6" className="animate-pulse" style={{ animationDuration: "2s", animationDelay: "1.5s" }} />
            <circle cx="130" cy="120" r="6" fill="#14B8A6" className="animate-pulse" style={{ animationDuration: "2s", animationDelay: "2s" }} />
            <circle cx="160" cy="90" r="6" fill="#14B8A6" className="animate-pulse" style={{ animationDuration: "2s", animationDelay: "2.5s" }} />
            <circle cx="190" cy="60" r="6" fill="#14B8A6" className="animate-pulse" style={{ animationDuration: "2s", animationDelay: "3s" }} />

            {/* Pie chart - moved to the top right to avoid overlap */}
            <circle cx="190" cy="120" r="30" fill="none" stroke="#2DD4BF" strokeWidth="2" />
            <path d="M190 120 L190 90 A30 30 0 0 1 216 135 Z" fill="#5EEAD4" fillOpacity="0.7" className="animate-rotate" style={{ transformOrigin: "190px 120px" }} />
            <path d="M190 120 L216 135 A30 30 0 0 1 164 135 Z" fill="#14B8A6" fillOpacity="0.7" className="animate-rotate" style={{ animationDelay: "1s", transformOrigin: "190px 120px" }} />
            <path d="M190 120 L164 135 A30 30 0 0 1 190 90 Z" fill="#0D9488" fillOpacity="0.7" className="animate-rotate" style={{ animationDelay: "2s", transformOrigin: "190px 120px" }} />
        </svg>
    );
};

// 3. Integration SVG with animation
export const IntegrationSVG = ({ className }) => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 240 240"
            className={className}
        >
            {/* Background */}
            <rect x="0" y="0" width="240" height="240" fill="none" />

            {/* Central hub */}
            <circle cx="120" cy="120" r="30" fill="#FDA4AF" fillOpacity="0.2" className="animate-pulse" style={{ animationDuration: "3s" }} />
            <circle cx="120" cy="120" r="20" fill="#FB7185" fillOpacity="0.5" />

            {/* Connection points (outer nodes) */}
            <circle cx="50" cy="70" r="12" fill="#E11D48" fillOpacity="0.7" className="animate-pulse" style={{ animationDuration: "2s" }} />
            <circle cx="50" cy="170" r="12" fill="#E11D48" fillOpacity="0.7" className="animate-pulse" style={{ animationDuration: "2.5s" }} />
            <circle cx="190" cy="70" r="12" fill="#E11D48" fillOpacity="0.7" className="animate-pulse" style={{ animationDuration: "3s" }} />
            <circle cx="190" cy="170" r="12" fill="#E11D48" fillOpacity="0.7" className="animate-pulse" style={{ animationDuration: "2.2s" }} />
            <circle cx="120" cy="40" r="12" fill="#E11D48" fillOpacity="0.7" className="animate-pulse" style={{ animationDuration: "2.7s" }} />
            <circle cx="120" cy="200" r="12" fill="#E11D48" fillOpacity="0.7" className="animate-pulse" style={{ animationDuration: "1.8s" }} />

            {/* Connection lines with animated data flow */}
            <line x1="120" y1="120" x2="50" y2="70" stroke="#FB7185" strokeWidth="2" strokeDasharray="5,5" />
            <line x1="120" y1="120" x2="50" y2="170" stroke="#FB7185" strokeWidth="2" strokeDasharray="5,5" />
            <line x1="120" y1="120" x2="190" y2="70" stroke="#FB7185" strokeWidth="2" strokeDasharray="5,5" />
            <line x1="120" y1="120" x2="190" y2="170" stroke="#FB7185" strokeWidth="2" strokeDasharray="5,5" />
            <line x1="120" y1="120" x2="120" y2="40" stroke="#FB7185" strokeWidth="2" strokeDasharray="5,5" />
            <line x1="120" y1="120" x2="120" y2="200" stroke="#FB7185" strokeWidth="2" strokeDasharray="5,5" />

            {/* Animated data packets */}
            <circle cx="0" cy="0" r="4" fill="#F43F5E" className="animate-data-flow" style={{ animationDuration: "3s" }}>
                <animateMotion
                    path="M120,120 L50,70"
                    dur="2s"
                    repeatCount="indefinite"
                    keyPoints="1;0"
                    keyTimes="0;1"
                    calcMode="linear"
                />
            </circle>
            <circle cx="0" cy="0" r="4" fill="#F43F5E" className="animate-data-flow" style={{ animationDuration: "3s" }}>
                <animateMotion
                    path="M120,120 L50,170"
                    dur="3s"
                    repeatCount="indefinite"
                    keyPoints="1;0"
                    keyTimes="0;1"
                    calcMode="linear"
                    begin="0.5s"
                />
            </circle>
            <circle cx="0" cy="0" r="4" fill="#F43F5E" className="animate-data-flow" style={{ animationDuration: "3s" }}>
                <animateMotion
                    path="M120,120 L190,70"
                    dur="2.5s"
                    repeatCount="indefinite"
                    keyPoints="1;0"
                    keyTimes="0;1"
                    calcMode="linear"
                    begin="1s"
                />
            </circle>
            <circle cx="0" cy="0" r="4" fill="#F43F5E" className="animate-data-flow" style={{ animationDuration: "3s" }}>
                <animateMotion
                    path="M120,120 L190,170"
                    dur="2.8s"
                    repeatCount="indefinite"
                    keyPoints="1;0"
                    keyTimes="0;1"
                    calcMode="linear"
                    begin="0.7s"
                />
            </circle>
            <circle cx="0" cy="0" r="4" fill="#F43F5E" className="animate-data-flow" style={{ animationDuration: "3s" }}>
                <animateMotion
                    path="M120,120 L120,40"
                    dur="2.2s"
                    repeatCount="indefinite"
                    keyPoints="1;0"
                    keyTimes="0;1"
                    calcMode="linear"
                    begin="0.3s"
                />
            </circle>
            <circle cx="0" cy="0" r="4" fill="#F43F5E" className="animate-data-flow" style={{ animationDuration: "3s" }}>
                <animateMotion
                    path="M120,120 L120,200"
                    dur="2.4s"
                    repeatCount="indefinite"
                    keyPoints="1;0"
                    keyTimes="0;1"
                    calcMode="linear"
                    begin="1.2s"
                />
            </circle>

            {/* Server icons inside nodes */}
            <rect x="113" y="113" width="14" height="14" rx="2" fill="#FFF1F2" fillOpacity="0.8" />
            <line x1="116" y1="116" x2="124" y2="116" stroke="#881337" strokeWidth="1" />
            <line x1="116" y1="119" x2="124" y2="119" stroke="#881337" strokeWidth="1" />
            <line x1="116" y1="122" x2="124" y2="122" stroke="#881337" strokeWidth="1" />

            <rect x="43" y="63" width="14" height="14" rx="2" fill="#FFF1F2" fillOpacity="0.8" />
            <rect x="43" y="163" width="14" height="14" rx="2" fill="#FFF1F2" fillOpacity="0.8" />
            <rect x="183" y="63" width="14" height="14" rx="2" fill="#FFF1F2" fillOpacity="0.8" />
            <rect x="183" y="163" width="14" height="14" rx="2" fill="#FFF1F2" fillOpacity="0.8" />
            <rect x="113" y="33" width="14" height="14" rx="2" fill="#FFF1F2" fillOpacity="0.8" />
            <rect x="113" y="193" width="14" height="14" rx="2" fill="#FFF1F2" fillOpacity="0.8" />
        </svg>
    );
};

// Add CSS keyframes for animations to your global CSS
// @keyframes draw-line {
//   from { stroke-dashoffset: 240; }
//   to { stroke-dashoffset: 0; }
// }
//
// @keyframes grow-up {
//   from { height: 0; }
//   to { height: 80px; }
// }
//
// @keyframes rotate {
//   from { transform: rotate(0deg); }
//   to { transform: rotate(360deg); }
// }
//
// @keyframes data-flow {
//   from { opacity: 1; }
//   to { opacity: 0.5; }
// }
//
// .animate-draw-line {
//   animation: draw-line 3s ease-in-out forwards;
// }
//
// .animate-grow-up {
//   animation: grow-up 2s ease-out forwards;
// }
//
// .animate-rotate {
//   animation: rotate 10s linear infinite;
// }
//
// .animate-data-flow {
//   animation: data-flow 1s ease-in-out infinite alternate;
// }
//
// .animate-spin-slow {
//   animation: spin 10s linear infinite;
// }
//
// .animate-dash {
//   animation: dash 15s linear infinite;
// }
//
// .animate-dash-reverse {
//   animation: dash 15s linear infinite reverse;
// }
//
// @keyframes dash {
//   to {
//     stroke-dashoffset: 1000;
//   }
// }